import { withSessionStorage, withStorageSync } from '@angular-architects/ngrx-toolkit'; // docs: https://github.com/angular-architects/ngrx-toolkit
import { signalStore, withState } from '@ngrx/signals';

import { withLockable } from 'app/home/create-quote/form-locking';
import { withQuoteDraftMethods } from 'app/home/global-store/quote-draft/effects/quote-draft.methods';
import { quoteDraftInitialState } from 'app/home/global-store/quote-draft/quote-draft-initial-state';
import { withQuoteDraftSelectors } from 'app/home/global-store/quote-draft/selectors/quote-draft.selectors';

/**
 * Quote Draft Store
 * - this is provided in the orchestration component
 * Great Intro Post: https://offering.solutions/blog/articles/2023/12/03/ngrx-signal-store-getting-started/
 */

export const QuoteDraftStore = signalStore(
  { providedIn: 'root' },
  withState(quoteDraftInitialState),
  // Selectors
  withQuoteDraftSelectors(),
  // Methods
  withQuoteDraftMethods(),
  withStorageSync(
    {
      key: 'quote',
      autoSync: true,
    },
    withSessionStorage(),
  ),
  withLockable(),
);
